import {Switch} from "@headlessui/react";
import * as React from "react";
import {useTranslation} from "react-i18next";

export const RegularSwitch = (props) => {
    const {
        translationIndex = '',
        value,
        setValue,
        textAbove = false,
        disabled = false
    } = props;

    const {t} = useTranslation();

    return (
        <>
            {
                textAbove && (
                    <p className="pl-2">{t(translationIndex)}</p>
                )
            }
            <div className={`flex flex-row ${textAbove ? 'my-auto' : ''}`}>
                <Switch
                    checked={value ?? false}
                    onChange={() => {
                        setValue(!value)
                    }}
                    value={value ?? false}
                    disabled={disabled}
                    className={`${
                        value ? 'bg-primary' : 'bg-gray-200'
                    } relative inline-flex h-6 w-11 items-center rounded-full ${
                        disabled ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                    <span className="sr-only">{t(translationIndex)}</span>
                    <span
                        className={`${value ?? null ? 'translate-x-6' : 'translate-x-1'} inline-block h-4 w-4 transform rounded-full bg-white transition`}
                    />
                </Switch>

                {
                    !textAbove && (
                        <p className="pl-2">{t(translationIndex)}</p>
                    )
                }

            </div>
        </>

    )
}